export default __webpack_public_path__ + "static/media/Capsicum.91a32876.jpg";